import ThemeContext, { ThemeConsumer } from "./ThemeContext";
export default ThemeContext;
export { ThemeContext, ThemeConsumer };
